module.exports = __webpack_public_path__ + "img/6510.56f4f2db.jpg";